import { apiRequest } from "../lib/apiClient";
import type { WebhookDeliveryOut, WebhookSubscriptionCreate, WebhookSubscriptionCreateResponse, WebhookSubscriptionOut } from "./types";

/** `GET /webhooks/subscriptions` — OWNER-only. Never re-displays `secret`. */
export async function listWebhookSubscriptions(accessToken: string): Promise<WebhookSubscriptionOut[]> {
  return apiRequest<WebhookSubscriptionOut[]>("/webhooks/subscriptions", { accessToken });
}

/** `POST /webhooks/subscriptions` — OWNER-only. The ONLY response that ever includes the
 * raw HMAC secret — shown once, never retrievable again. */
export async function createWebhookSubscription(
  accessToken: string,
  body: WebhookSubscriptionCreate,
): Promise<WebhookSubscriptionCreateResponse> {
  return apiRequest<WebhookSubscriptionCreateResponse>("/webhooks/subscriptions", { method: "POST", accessToken, body });
}

/** `DELETE /webhooks/subscriptions/{id}` — OWNER-only. Soft delete + deactivates. */
export async function deleteWebhookSubscription(accessToken: string, subscriptionId: string): Promise<void> {
  await apiRequest<void>(`/webhooks/subscriptions/${subscriptionId}`, { method: "DELETE", accessToken });
}

/** `GET /webhooks/deliveries` — OWNER-only. Optional `subscription_id` filter. */
export async function listWebhookDeliveries(accessToken: string, subscriptionId?: string): Promise<WebhookDeliveryOut[]> {
  return apiRequest<WebhookDeliveryOut[]>("/webhooks/deliveries", { accessToken, query: { subscription_id: subscriptionId } });
}
